import { render, staticRenderFns } from "./flex-grid-item.vue?vue&type=template&id=127f407c"
import script from "./flex-grid-item.vue?vue&type=script&lang=js"
export * from "./flex-grid-item.vue?vue&type=script&lang=js"
import style0 from "./flex-grid-item.vue?vue&type=style&index=0&id=127f407c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports